document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.adhdblox-filters').forEach((filterArea) => {
    const sectionId = filterArea.dataset.sectionId;
    const productGrid = document.querySelector(`#Slider-${sectionId}`);

    if (!productGrid) return;

    const searchInput = filterArea.querySelector(
      '.adhdblox-filters__search-input'
    );

    const countElement = filterArea.querySelector(
      '.adhdblox-filters__count'
    );

    const quickLinks = Array.from(
      filterArea.querySelectorAll(
        '.adhdblox-filters__quick-links button'
      )
    );

    const filters = {
      brainrot: {
        toggle: filterArea.querySelector(
          '[data-filter-toggle="brainrot"]'
        ),
        menu: filterArea.querySelector(
          `#BrainrotMenu-${sectionId}`
        ),
        label: filterArea.querySelector(
          `#BrainrotLabel-${sectionId}`
        ),
        clear: filterArea.querySelector(
          `#BrainrotClear-${sectionId}`
        ),
        defaultLabel: 'Brainrots',
        allLabel: 'All Brainrots',
        cardDataset: 'brainrot',
        buttonAttribute: 'data-brainrot',
        selectedValue: '',
      },

      mutation: {
        toggle: filterArea.querySelector(
          '[data-filter-toggle="mutation"]'
        ),
        menu: filterArea.querySelector(
          `#MutationMenu-${sectionId}`
        ),
        label: filterArea.querySelector(
          `#MutationLabel-${sectionId}`
        ),
        clear: filterArea.querySelector(
          `#MutationClear-${sectionId}`
        ),
        defaultLabel: 'Mutations',
        allLabel: 'All Mutations',
        cardDataset: 'mutation',
        buttonAttribute: 'data-mutation',
        selectedValue: '',
      },

      speed: {
        toggle: filterArea.querySelector(
          '[data-filter-toggle="speed"]'
        ),
        menu: filterArea.querySelector(
          `#SpeedMenu-${sectionId}`
        ),
        label: filterArea.querySelector(
          `#SpeedLabel-${sectionId}`
        ),
        clear: filterArea.querySelector(
          `#SpeedClear-${sectionId}`
        ),
        defaultLabel: 'M/s',
        allLabel: 'All speeds',
        cardDataset: 'speedRange',
        buttonAttribute: 'data-speed',
        selectedValue: '',
      },
    };

    const normalize = (value) =>
      String(value || '')
        .normalize('NFKC')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    const getCards = () =>
      Array.from(
        productGrid.querySelectorAll('.product-card-wrapper')
      );

    const getGridItem = (card) =>
      card.closest('.grid__item');

    const closeAllMenus = () => {
      Object.values(filters).forEach((filter) => {
        if (filter.menu) {
          filter.menu.hidden = true;
        }

        filter.toggle?.setAttribute(
          'aria-expanded',
          'false'
        );
      });
    };

    const getUniqueValues = (datasetName) => {
      const uniqueValues = new Map();

      getCards().forEach((card) => {
        const rawValue = String(card.dataset[datasetName] || '')
          .normalize('NFKC')
          .replace(/\s+/g, ' ')
          .trim();

        if (!rawValue) return;

        const key = normalize(rawValue);

        if (!uniqueValues.has(key)) {
          uniqueValues.set(key, rawValue);
        }
      });

      if (
        datasetName === 'mutation' &&
        !uniqueValues.has('crystal')
      ) {
        uniqueValues.set('crystal', 'Crystal');
      }

      return Array.from(uniqueValues.values()).sort((a, b) =>
        a.localeCompare(b, undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      );
    };

    const populateMenu = (filter) => {
      if (!filter.menu) return;

      filter.menu
        .querySelectorAll(
          `[${filter.buttonAttribute}]:not([${filter.buttonAttribute}=""])`
        )
        .forEach((button) => button.remove());

      const values = getUniqueValues(filter.cardDataset);

      values.forEach((value) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.setAttribute(filter.buttonAttribute, value);
        button.textContent = value;

        filter.menu.appendChild(button);
      });
    };

    const populateAllMenus = () => {
      Object.values(filters).forEach(populateMenu);
    };

    const updateFilterDisplay = (filter) => {
      if (filter.label) {
        filter.label.textContent =
          filter.selectedValue || filter.defaultLabel;
      }

      if (filter.clear) {
        filter.clear.hidden = !filter.selectedValue;
      }
    };

    const clearAllCategoryFilters = () => {
      Object.values(filters).forEach((filter) => {
        filter.selectedValue = '';
        updateFilterDisplay(filter);
      });
    };

    const updateQuickLinks = () => {
      const selectedBrainrot = normalize(
        filters.brainrot.selectedValue
      );

      quickLinks.forEach((button) => {
        const value = normalize(button.dataset.quickValue);

        const isActive =
          selectedBrainrot &&
          value === selectedBrainrot;

        button.classList.toggle('is-active', Boolean(isActive));

        const clearIcon = button.querySelector(
          '.adhdblox-filters__quick-clear'
        );

        if (isActive && !clearIcon) {
          const icon = document.createElement('span');

          icon.className =
            'adhdblox-filters__quick-clear';

          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '\u00d7';

          button.appendChild(icon);
        }

        if (!isActive && clearIcon) {
          clearIcon.remove();
        }
      });
    };

    const updateProducts = () => {
      const searchValue = normalize(searchInput?.value);

      const selectedBrainrot = normalize(
        filters.brainrot.selectedValue
      );

      const selectedMutation = normalize(
        filters.mutation.selectedValue
      );

      const selectedSpeed = normalize(
        filters.speed.selectedValue
      );

      const filtersAreActive = Boolean(
        searchValue ||
        selectedBrainrot ||
        selectedMutation ||
        selectedSpeed
      );

      const visibleProducts = new Set();
      const countProduct = (card) => {
        const link = card.querySelector('a[href*="/products/"]');
        const handle = link?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
        if (handle) visibleProducts.add(handle);
      };

      getCards().forEach((card) => {
        const title = normalize(card.dataset.productTitle);
        const brainrot = normalize(card.dataset.brainrot);
        const mutation = normalize(card.dataset.mutation);
        const speed = normalize(card.dataset.speedRange);

        const matchesSearch =
          !searchValue ||
          title.includes(searchValue) ||
          brainrot.includes(searchValue) ||
          mutation.includes(searchValue) ||
          speed.includes(searchValue);

        const matchesBrainrot =
          !selectedBrainrot ||
          brainrot === selectedBrainrot;

        const matchesMutation =
          !selectedMutation ||
          mutation === selectedMutation;

        const matchesSpeed =
          !selectedSpeed ||
          speed === selectedSpeed;

        let shouldShow =
          matchesSearch &&
          matchesBrainrot &&
          matchesMutation &&
          matchesSpeed;

        const gridItem = getGridItem(card);

        if (!gridItem) return;

        const isSpecialFilterCopy = gridItem.hasAttribute(
          'data-adhdblox-filter-special-copy'
        );

        if (isSpecialFilterCopy && !filtersAreActive) {
          shouldShow = false;
        }

        gridItem.hidden = !shouldShow;

        if (shouldShow) {
          countProduct(card);
        }
      });

      if (!filtersAreActive) {
        document.querySelectorAll('[data-adhdblox-special-row]').forEach((row) => {
          if (row.dataset.adhdbloxSectionId !== sectionId) return;
          row.querySelectorAll('.product-card-wrapper').forEach((card) => {
            const item = getGridItem(card);
            if (item && !item.hidden) countProduct(card);
          });
        });
      }

      if (countElement) {
        countElement.textContent =
          `${visibleProducts.size} items found`;
      }

      updateQuickLinks();
      updateMobileFilterCount();
    };

    /* =========================================================
       MOBILFILTER
       ========================================================= */

    const mobileFilterToggle = filterArea.querySelector(
      '.adhdblox-filters__mobile-toggle'
    );

    const mobileFilterDrawer = filterArea.querySelector(
      '.adhdblox-filters__mobile-drawer'
    );

    const mobileFilterBackdrop = filterArea.querySelector(
      '.adhdblox-filters__mobile-backdrop'
    );

    const mobileFilterCloseButtons = filterArea.querySelectorAll(
      '[data-mobile-filter-close]'
    );

    const mobileClearAll = filterArea.querySelector(
      '[data-mobile-clear-all]'
    );

    /* --- Filterräknare på Filters-knappen --- */

    const updateMobileFilterCount = () => {
      if (!mobileFilterToggle) return;

      const activeCount = Object.values(filters).filter(
        (filter) => filter.selectedValue
      ).length;

      const labelSpan = mobileFilterToggle.querySelector('span');

      if (labelSpan) {
        labelSpan.textContent =
          activeCount > 0 ? `Filters (${activeCount})` : 'Filters';
      }
    };

    /* --- Underpaneler (Brainrot / Mutations / M/s) --- */

    const mobilePanels = {};

    filterArea
      .querySelectorAll('[data-mobile-panel]')
      .forEach((panel) => {
        mobilePanels[panel.dataset.mobilePanel] = {
          panel,
          search: panel.querySelector('[data-mobile-panel-search]'),
          list: panel.querySelector('[data-mobile-panel-list]'),
        };
      });

    const updateMobileSelectedLabels = () => {
      filterArea
        .querySelectorAll('[data-mobile-selected]')
        .forEach((span) => {
          const key = span.dataset.mobileSelected;

          if (!filters[key]) return;

          const value = filters[key].selectedValue;

          span.innerHTML = '';

          if (!value) return;

          const chip = document.createElement('span');
          chip.className = 'adhdblox-filters__mobile-chip';

          const text = document.createElement('span');
          text.className = 'adhdblox-filters__mobile-chip-text';
          text.textContent = value;

          const clear = document.createElement('span');
          clear.className = 'adhdblox-filters__mobile-chip-clear';
          clear.setAttribute('data-mobile-chip-clear', key);
          clear.setAttribute('role', 'button');
          clear.setAttribute('tabindex', '0');
          clear.setAttribute('aria-label', `Remove ${value}`);
          clear.textContent = '\u00d7';

          chip.appendChild(text);
          chip.appendChild(clear);
          span.appendChild(chip);
        });
    };

    const clearMobileFilter = (key) => {
      if (!filters[key]) return;

      filters[key].selectedValue = '';

      updateFilterDisplay(filters[key]);
      updateMobileSelectedLabels();
      updateProducts();
    };

    const closeAllMobilePanels = () => {
      Object.values(mobilePanels).forEach(({ panel }) => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
    };

    const renderMobilePanelList = (key) => {
      const entry = mobilePanels[key];
      const filter = filters[key];

      if (!entry || !filter || !entry.list) return;

      const searchValue = normalize(entry.search?.value);
      const values = getUniqueValues(filter.cardDataset);
      const selected = normalize(filter.selectedValue);

      entry.list.innerHTML = '';

      const allButton = document.createElement('button');

      allButton.type = 'button';
      allButton.className = 'adhdblox-filters__mobile-panel-item';
      allButton.setAttribute('data-mobile-panel-value', '');
      allButton.textContent = filter.allLabel;

      if (!selected) {
        allButton.classList.add('is-selected');
      }

      entry.list.appendChild(allButton);

      values.forEach((value) => {
        if (
          searchValue &&
          !normalize(value).includes(searchValue)
        ) {
          return;
        }

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'adhdblox-filters__mobile-panel-item';
        button.setAttribute('data-mobile-panel-value', value);
        button.textContent = value;

        if (normalize(value) === selected) {
          button.classList.add('is-selected');
        }

        entry.list.appendChild(button);
      });
    };

    const openMobilePanel = (key) => {
      const entry = mobilePanels[key];

      if (!entry) return;

      closeAllMobilePanels();

      if (entry.search) {
        entry.search.value = '';
      }

      renderMobilePanelList(key);

      entry.panel.classList.add('is-open');
      entry.panel.setAttribute('aria-hidden', 'false');
    };

    const openMobileFilters = () => {
      if (!mobileFilterDrawer || !mobileFilterBackdrop) return;

      closeAllMobilePanels();
      updateMobileSelectedLabels();

      mobileFilterDrawer.classList.add('is-open');
      mobileFilterBackdrop.classList.add('is-visible');

      mobileFilterDrawer.setAttribute('aria-hidden', 'false');
      mobileFilterBackdrop.hidden = false;

      document.body.classList.add('adhdblox-mobile-filter-open');

      if (mobileFilterToggle) {
        mobileFilterToggle.setAttribute('aria-expanded', 'true');
      }
    };

    const closeMobileFilters = () => {
      if (!mobileFilterDrawer || !mobileFilterBackdrop) return;

      mobileFilterDrawer.classList.remove('is-open');
      mobileFilterBackdrop.classList.remove('is-visible');

      mobileFilterDrawer.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('adhdblox-mobile-filter-open');

      if (mobileFilterToggle) {
        mobileFilterToggle.setAttribute('aria-expanded', 'false');
      }

      window.setTimeout(() => {
        if (!mobileFilterBackdrop.classList.contains('is-visible')) {
          mobileFilterBackdrop.hidden = true;
        }

        closeAllMobilePanels();
      }, 250);
    };

    if (mobileFilterToggle) {
      mobileFilterToggle.addEventListener('click', openMobileFilters);
    }

    mobileFilterCloseButtons.forEach((button) => {
      button.addEventListener('click', closeMobileFilters);
    });

    if (mobileClearAll) {
      mobileClearAll.addEventListener('click', () => {
        clearAllCategoryFilters();

        if (searchInput) {
          searchInput.value = '';
        }

        updateMobileSelectedLabels();
        updateQuickLinks();
        closeAllMenus();
        closeAllMobilePanels();
        updateProducts();
      });
    }

    filterArea
      .querySelectorAll('[data-mobile-filter-target]')
      .forEach((button) => {
        button.addEventListener('click', (event) => {
          const chipClear = event.target.closest(
            '[data-mobile-chip-clear]'
          );

          if (chipClear) {
            event.preventDefault();
            event.stopPropagation();

            clearMobileFilter(
              chipClear.getAttribute('data-mobile-chip-clear')
            );

            return;
          }

          openMobilePanel(button.dataset.mobileFilterTarget);
        });
      });

    Object.entries(mobilePanels).forEach(([key, entry]) => {
      entry.search?.addEventListener('input', () => {
        renderMobilePanelList(key);
      });

      entry.search?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        /* Ren sökning som på desktop: rensa valda kategorifilter
           innan söktexten appliceras, annars AND-kombineras de och
           ger färre träffar än förväntat. */
        clearAllCategoryFilters();
        updateMobileSelectedLabels();

        if (searchInput) {
          searchInput.value = entry.search.value;
        }

        updateProducts();
        closeMobileFilters();
      });

      entry.panel
        .querySelector('[data-mobile-panel-back]')
        ?.addEventListener('click', closeAllMobilePanels);

      entry.list?.addEventListener('click', (event) => {
        const button = event.target.closest(
          '[data-mobile-panel-value]'
        );

        if (!button) return;

        filters[key].selectedValue =
          button.getAttribute('data-mobile-panel-value') || '';

        updateFilterDisplay(filters[key]);
        updateMobileSelectedLabels();
        updateProducts();
        closeAllMobilePanels();
      });
    });

    /* ========================================================= */

    Object.values(filters).forEach((filter) => {
      updateFilterDisplay(filter);

      filter.clear?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        filter.selectedValue = '';

        updateFilterDisplay(filter);
        closeAllMenus();
        updateProducts();
      });

      filter.toggle?.addEventListener('click', (event) => {
        const clickedClear = event.target.closest(
          '.adhdblox-filters__clear'
        );

        if (clickedClear) return;

        event.stopPropagation();

        const shouldOpen = filter.menu?.hidden;

        closeAllMenus();

        if (filter.menu && shouldOpen) {
          filter.menu.hidden = false;

          filter.toggle.setAttribute(
            'aria-expanded',
            'true'
          );
        }
      });

      filter.menu?.addEventListener('click', (event) => {
        const button = event.target.closest(
          `[${filter.buttonAttribute}]`
        );

        if (!button) return;

        filter.selectedValue =
          button.getAttribute(filter.buttonAttribute) || '';

        updateFilterDisplay(filter);
        closeAllMenus();
        updateProducts();
      });
    });

    searchInput?.addEventListener('input', updateProducts);

    quickLinks.forEach((button) => {
      const originalText = button.textContent.trim();

      button.dataset.quickValue = originalText;

      button.addEventListener('click', (event) => {
        event.preventDefault();

        const clickedValue =
          button.dataset.quickValue || '';

        const alreadySelected =
          normalize(filters.brainrot.selectedValue) ===
          normalize(clickedValue);

        filters.brainrot.selectedValue =
          alreadySelected ? '' : clickedValue;

        updateFilterDisplay(filters.brainrot);

        if (searchInput) {
          searchInput.value = '';
        }

        closeAllMenus();
        updateProducts();
      });
    });

    document.addEventListener('click', (event) => {
      if (!filterArea.contains(event.target)) {
        closeAllMenus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllMenus();
        closeMobileFilters();
      }
    });

    let refreshTimeout;

    const gridObserver = new MutationObserver(() => {
      clearTimeout(refreshTimeout);

      refreshTimeout = setTimeout(() => {
        populateAllMenus();
        updateProducts();
      }, 100);
    });

    gridObserver.observe(productGrid, {
      childList: true,
      subtree: true,
    });

    populateAllMenus();
    updateProducts();
  });
});
